import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

interface DrawerProps extends MuiDrawerProps {
    open?: boolean;
    drawerWidth?: number;
    hidden?: boolean;
}

export const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop: string) => !['open', 'drawerWidth', 'hidden'].includes(prop),
})<DrawerProps>(({ theme, open, drawerWidth = 240, hidden: hideSideNavBar }) => ({
    height: '100%',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
    [theme.breakpoints.up('md')]: {
        display: hideSideNavBar ? 'none' : 'block',
    },
    '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        boxSizing: 'border-box',
        textWrap: 'wrap',
        ...(!open && {
            overflowX: 'hidden',
            width: theme.spacing(7),
            [theme.breakpoints.up('md')]: {
                width: theme.spacing(8.5),
            },
            '& .drawer-label': {
                display: 'none',
            },
        }),
        '& .selected': {
            '& .MuiTypography-root': {
                fontWeight: 'bold',
            },
        },
        '& .header-spacing': {
            minHeight: '91px',
        },
        '& #drawer-action-icon': {
            justifyContent: open ? 'flex-end' : 'normal',
            width: open ? '100%' : '',

            '& svg': {
                fontSize: '2rem',
            },
        },
    },
}));
